import SectionHead from "./SectionHead";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const Process = ({ t }) => (
  <section className="section" id="process" data-testid="process-section">
    <div className="wrap">
      <SectionHead eyebrow={t.processLabel} title={t.processTitle} />
      <ol className="steps">
        {t.steps.map(([name, desc], i) => (
          <li className={`step s${i + 1} ${i % 2 ? "even" : "odd"}`} style={{ "--c": i + 1 }} key={i}>
            <motion.div
              className="bubble"
              initial={{ opacity: 0, scale: 0.6 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`process-bubble-${i + 1}`}
            >
              <small className="mono">{`0${i + 1}`}</small>
              <h3>{name}</h3>
            </motion.div>
            <p className="step-text">{desc}</p>
          </li>
        ))}
        <li className="loop" aria-hidden="true">
          <span className="mono">{t.loopLabel}</span>
        </li>
      </ol>
      <Reveal>
        <p className="process-note">{t.processNote}</p>
      </Reveal>
    </div>
  </section>
);

export default Process;
